/**
 * Haelt den Gesamtblock am rechten Rand einer breiten Tabelle stehen.
 *
 * Bei Tabellen, die ueber viele Spalten laufen (36 Monate im Unterricht, drei Spalten
 * je Fachbereich im Praktikum), waere die Gesamtspalte sonst nie im Bild, und genau sie
 * beantwortet die eigentliche Frage.
 *
 * Die Rechtsabstaende werden gemessen und nicht geschaetzt: wie breit eine Spalte wird,
 * entscheidet der Tabellensatz aus ihrer Ueberschrift, und "Unentsch." saetzt breiter
 * als "Ist". Mit festen Werten kacheln die Spalten nicht mehr lueckenlos, und beim
 * Querscrollen blitzen die darunterliegenden Spalten zwischen ihnen durch.
 */
export function layoutStickyTotals(root: HTMLElement, cls: string, count: number): void {
  const heads = Array.from(root.querySelectorAll<HTMLElement>(`thead tr:last-child .${cls}`));
  if (heads.length !== count) return;

  // Abstand einer Spalte zum rechten Rand ist die Summe der Breiten rechts von ihr.
  const rights: number[] = [];
  let gesamt = 0;
  for (let i = count - 1; i >= 0; i--) { rights[i] = gesamt; gesamt += heads[i].getBoundingClientRect().width; }

  root.querySelectorAll<HTMLElement>("tr").forEach(tr => {
    const cells = Array.from(tr.querySelectorAll<HTMLElement>(`.${cls}`));
    if (cells.length === count) {
      cells.forEach((c, i) => { c.style.right = `${rights[i]}px`; });
    } else if (cells.length === 1) {
      // Eine Zelle ueber den ganzen Block, etwa die Ueberschrift "Gesamt" oder ein
      // Balken, der sich ueber alle Unterspalten zieht.
      cells[0].style.right = "0px";
      cells[0].style.width = `${gesamt}px`;
      cells[0].style.minWidth = `${gesamt}px`;
    }
    // Zeilen ohne Gesamtzellen (Klassentrenner, aufgeklappte Details) laufen bewusst
    // durch: sie spannen ohnehin ueber die ganze Breite.
  });
}
